export enum DateFieldName {
  CollectionDay = 'uds_rap_abholtag',
  HandoverToUser = 'new__rap_uebergabe_nutzer',
  StartOfRepair = 'uds_rap_reparaturbeginn',
  EndOfRepair = 'uds_rap_reparartur_ende'
}
